<template>
  <v-select @input="$emit('change',$event.user)" :placeholder="placeholder" :options="users" dir="rtl">
    <span slot="no-options">لطفا منتظر بمانید...</span>
  </v-select>
</template>

<script>
  import vSelect from 'vue-select'

  export default {
    name: "SelectUser",
    mounted() {
      if (this.role === 'student') {
        if (!this.$store.state.students.length)
          this.$store.dispatch('fetchStudents')
      } else if (this.role === 'driver') {
        if (!this.$store.state.drivers.length)
          this.$store.dispatch('fetchDrivers')
      }
    },
    components: {
      'v-select': vSelect
    },
    computed: {
      users() {
        return this.$store.state[this.role+'s'].map(i => {
          let userIds = this.$store.state.usersWhoNeedMsg.map(u => u.id)
          if (!userIds.includes(i.id))
            return {
              value: i.id,
              label: i.firstName + ' ' + i.lastName,
              user: i
            }
        }).filter(i => i)
      }
    },
    props: {
      role: {
        Type: String,
        default: 'student'
      },
      placeholder: {
        Type: String,
        default: 'انتخاب دانش آموز'
      }
    }
  }
</script>

<style scoped>

</style>
